module.exports = __webpack_public_path__ + "media/images/static/top/urban/center_photo-4f6ce3af2a36b137f336812b8039b4fa.png";